var React = require('react');

function DoneTool (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z","fill":"#00B16A","key":0}),React.createElement("path",{"d":"M8.76061 4.20026L4.80061 7.80026L3.00061 6.16389","stroke":"white","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

DoneTool.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = DoneTool;

DoneTool.default = DoneTool;
